import { render, staticRenderFns } from "./CaseBatchEdit.vue?vue&type=template&id=68249ad3"
import script from "./CaseBatchEdit.vue?vue&type=script&lang=js"
export * from "./CaseBatchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports